// dev_lp — "What's in it for you?" section: personal import vs commercial importers.
import React from "react";
import { useTranslation } from "react-i18next";
import CheckIcon from "../components/CheckIcon";
import SectionHeading from "../components/SectionHeading";
import M1PetrolDieselCarIcon from "../../../assets/icons/m1-petrol-diesel-car.svg";

const BenefitsSection: React.FC = () => {
  const { t } = useTranslation();

  const personalItems = t("benefits.personalItems", {
    returnObjects: true,
  }) as string[];
  const commercialItems = t("benefits.commercialItems", {
    returnObjects: true,
  }) as string[];

  const Card: React.FC<{
    title: string;
    items: string[];
    icon: React.ReactNode;
  }> = ({ title, items, icon }) => (
    <div className="bg-white/80 backdrop-blur rounded-3xl p-8 shadow-xl shadow-blue-900/5 ring-1 ring-white/60 hover:shadow-2xl hover:-translate-y-1 transition-all">
      <h3
        className="text-xl md:text-2xl font-bold mb-6 flex items-center gap-3"
        style={{ color: "#003B7B" }}
      >
        {icon}
        {title}
      </h3>
      <ul className="space-y-4">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-3">
            <CheckIcon className="mt-0.5" />
            <span className="text-gray-800 leading-relaxed">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <section className="max-w-5xl mx-auto px-4 sm:px-6 mb-20">
      <SectionHeading className="mb-12">{t("benefits.title")}</SectionHeading>

      <div className="grid md:grid-cols-2 gap-7">
        <Card
          title={t("benefits.personalTitle")}
          items={personalItems}
          icon={
            <img
              src={M1PetrolDieselCarIcon}
              alt={t("a11y.carImageAlt")}
              className="w-10 h-10 object-contain"
            />
          }
        />
        <Card
          title={t("benefits.commercialTitle")}
          items={commercialItems}
          icon={<span className="text-3xl">📋</span>}
        />
      </div>
    </section>
  );
};

export default BenefitsSection;
